import React, { useEffect, useState, useRef } from "react";
import { Bell, AlertTriangle, Clock, MessageSquare, X } from "lucide-react";
import { api } from "../api/client";

export default function NotificationsDropdown({ onNavigate }) {
  const [open, setOpen] = useState(false);
  const [data, setData] = useState({ items: [], unread_count: 0, pending_rides: 0, open_sos: 0, unread_whatsapp: 0 });
  const [loading, setLoading] = useState(false);
  const timerRef = useRef(null);

  const load = async () => {
    try {
      setLoading(true);
      const res = await api.get("/notifications");
      setData(res.data);
    } catch (e) {} finally { setLoading(false); }
  };

  useEffect(() => {
    load();
    timerRef.current = setInterval(load, 20000); // refresh cada 20s
    return () => clearInterval(timerRef.current);
  }, []);

  const iconFor = (t) => {
    if (t === "sos") return <AlertTriangle className="w-4 h-4 text-red-500" />;
    if (t === "pending_ride") return <Clock className="w-4 h-4 text-amber-500" />;
    if (t === "whatsapp") return <MessageSquare className="w-4 h-4 text-emerald-500" />;
    return <Bell className="w-4 h-4 text-neutral-400" />;
  };

  return (
    <div className="relative">
      <button
        className="btn-ghost !text-white hover:!bg-white/10 !p-2 relative"
        title="Notificaciones"
        onClick={() => setOpen(v => !v)}
        data-testid="topbar-notifications"
      >
        <Bell className="w-4 h-4" strokeWidth={2.5} />
        {data.unread_count > 0 && (
          <span className="absolute -top-0.5 -right-0.5 text-[9px] font-bold bg-[#D13438] rounded-full min-w-[16px] h-4 px-1 flex items-center justify-center">
            {data.unread_count > 99 ? "99+" : data.unread_count}
          </span>
        )}
      </button>

      {open && (
        <>
          <div className="fixed inset-0 z-40" onClick={() => setOpen(false)} />
          <div className="absolute right-0 top-full mt-1 w-96 max-h-[70vh] bg-white text-neutral-800 rounded shadow-xl border border-neutral-200 z-50 fade-in flex flex-col" data-testid="notifications-dropdown">
            <div className="flex items-center justify-between px-4 py-3 border-b border-neutral-200">
              <div>
                <div className="font-semibold text-sm">Notificaciones</div>
                <div className="text-xs text-neutral-500">
                  {data.open_sos > 0 && <span className="text-red-600 font-semibold">{data.open_sos} SOS </span>}
                  · {data.pending_rides} pendientes · {data.unread_whatsapp} WhatsApp
                </div>
              </div>
              <button onClick={() => setOpen(false)} className="p-1 rounded hover:bg-neutral-100">
                <X className="w-4 h-4" />
              </button>
            </div>
            <div className="overflow-y-auto flex-1">
              {loading && data.items.length === 0 ? (
                <div className="p-8 text-center text-sm text-neutral-500">Cargando...</div>
              ) : data.items.length === 0 ? (
                <div className="p-8 text-center text-sm text-neutral-500">
                  <Bell className="w-8 h-8 mx-auto text-neutral-300 mb-2" />
                  No hay notificaciones nuevas
                </div>
              ) : (
                data.items.map((item, i) => (
                  <button
                    key={item.id + i}
                    onClick={() => {
                      if (item.action && onNavigate) onNavigate(item.action);
                      setOpen(false);
                    }}
                    className={`w-full text-left px-4 py-3 border-b border-neutral-100 hover:bg-neutral-50 transition ${item.severity === 'critical' ? 'bg-red-50' : ''}`}
                    data-testid={`notif-${item.type}-${i}`}
                  >
                    <div className="flex items-start gap-3">
                      <div className="mt-0.5">{iconFor(item.type)}</div>
                      <div className="flex-1 min-w-0">
                        <div className="text-sm font-semibold text-neutral-800 truncate">{item.title}</div>
                        <div className="text-xs text-neutral-500 truncate mt-0.5">{item.subtitle}</div>
                        {item.time && (
                          <div className="text-[10px] text-neutral-400 mt-1">
                            {new Date(item.time).toLocaleString('es-PE', { day:'2-digit', month:'2-digit', hour:'2-digit', minute:'2-digit'})}
                          </div>
                        )}
                      </div>
                    </div>
                  </button>
                ))
              )}
            </div>
          </div>
        </>
      )}
    </div>
  );
}
